import React, { Component } from "react";
import UserMaintenanceAdmin from "../FunctionComponents/UserMaintenance/UserMaintenanceAdmin";

class UserMaintenance extends Component {
  render() {
    return (
      <div>
        < UserMaintenanceAdmin />
      </div>
    );
  }
}

export default UserMaintenance;